<script setup lang="ts">
import { getPassageDetail } from '~/apis/data'
import {nl2br} from "~/common/TextFormatter";
import {useCache} from "~/common/useCache";

// GA Analytics 추가
const { trackEvent } = useAnalytics()

const app = useAppStore()
const passageStorage = usePassageStorage()

const passageDetailData = ref<any>({})

// ESC 키 이벤트 핸들러
const handleEscapeKey = (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    passageStorage.closePassageDetail()
  }
}

// 지문 상세 조회
const passageDetail = async () => {
  const res = await getPassageDetail({
    UM_ID: app.user.UM_ID,
    EDP_IDX: passageStorage.state.value.passageDetail.edp_idx,
  })
  if (res.data) {
    passageDetailData.value = res.data.data
  } else {
    console.log('지문 상세 조회 실패')
  }
}

// 수정 팝업으로 이동
const moveToPassageInput = () => {
  // GA 이벤트: 수정하기 버튼 클릭
  try {
    trackEvent('passagestorage_detail_edit_clicked', {
      event_category: 'item_interaction',
      passage_id: passageDetailData.value.edp_idx,
      passage_title: passageDetailData.value.edp_title,
      passage_type: passageDetailData.value.passage_type_name,
      creturn_type: passageDetailData.value.creturn_name,
      um_idx: app.user.UM_IDX ?? '',
      timestamp: new Date().toISOString()
    })
  } catch (error) {
    console.warn('GA tracking failed:', error)
  }
  
  passageStorage.state.value.passageInput.edp_idx =
    passageDetailData.value.edp_idx
  passageStorage.closePassageDetail()
  passageStorage.openPassageInput()
}

// 팝업 닫기 핸들러
const handleCloseDetail = () => {
  // GA 이벤트: 상세보기 팝업 닫기
  try {
    trackEvent('passagestorage_detail_closed', {
      event_category: 'ui_interaction',
      passage_id: passageDetailData.value.edp_idx,
      passage_title: passageDetailData.value.edp_title,
      view_duration_ms: Date.now() - (passageDetailData.value.view_start_time || Date.now()),
      um_idx: app.user.UM_IDX ?? '',
      timestamp: new Date().toISOString()
    })
  } catch (error) {
    console.warn('GA tracking failed:', error)
  }
  
  passageStorage.closePassageDetail()
}

onMounted(async () => {
  // GA 이벤트: 상세보기 팝업 열림
  try {
    trackEvent('passagestorage_detail_opened', {
      event_category: 'ui_interaction',
      passage_id: passageStorage.state.value.passageDetail.edp_idx,
      action_source: 'passage_click',
      um_idx: app.user.UM_IDX ?? '',
      timestamp: new Date().toISOString()
    })
  } catch (error) {
    console.warn('GA tracking failed:', error)
  }
  
  // 조회 시작 시간 기록 (닫기 시 체류시간 측정용)
  passageDetailData.value.view_start_time = Date.now()
  
  await passageDetail()

  // ESC 키 이벤트 리스너 등록
  document.addEventListener('keydown', handleEscapeKey)
})
onUnmounted(() => {
  // 이벤트 리스너 해제
  document.removeEventListener('keydown', handleEscapeKey)
})
</script>

<template>
  <!-- 지문 상세 -->
  <div class="layer active">
    <div class="mask"></div>
    <div class="inner">
      <section class="sample fullHeight">
        <header class="">
          <h2>{{ passageDetailData.edp_title }}</h2>
          <a class="layerClose" @click="handleCloseDetail"
            >닫기</a
          >
        </header>
        <main>
          <div class="writeType01">
            <dl>
              <dt>줄바꿈 유형</dt>
              <dd>{{ passageDetailData.creturn_name }}</dd>
            </dl>
            <dl>
              <dt>지문 제목</dt>
              <dd>{{ passageDetailData.edp_title }}</dd>
            </dl>
            <dl>
              <dt>지문 내용</dt>
              <dd v-dompurify-html="nl2br(passageDetailData.passage)">
              </dd>
            </dl>
            <dl>
              <dt>한글 해석</dt>
              <dd v-dompurify-html="nl2br(passageDetailData.passage_kr)">
              </dd>
            </dl>
          </div>
        </main>
        <footer>
          <div class="btnWrap">
            <a class="btnStyle wide" @click="moveToPassageInput"> 수정하기 </a>
          </div>
        </footer>
      </section>
    </div>
  </div>
  <!-- /지문 상세 -->
</template>

<style scoped></style>
